import React from 'react';
import { Typography } from '@mui/material';
import LegalPage from '../../components/LegalPage/LegalPage';

const Terms = () => (
    <LegalPage product="CVPro" title="Terms &amp; Conditions">
        <p><strong>Effective Date:</strong> March 22, 2026</p>

        <Typography variant="h6">1. Service Overview</Typography>
        <p>
            CVPro allows users to create, manage, and export resumes.
        </p>

        <Typography variant="h6">2. User Responsibility</Typography>
        <p>
            You are responsible for the accuracy of your resume content.
        </p>

        <Typography variant="h6">3. Subscription</Typography>
        <ul>
            <li>Some features may require payment</li>
            <li>Managed via Apple/Google billing systems</li>
        </ul>

        <Typography variant="h6">4. Content Ownership</Typography>
        <p>
            You retain ownership of all content created.
        </p>

        <Typography variant="h6">5. Acceptable Use</Typography>
        <p>
            You agree not to use CVPro for unlawful or fraudulent purposes.
        </p>

        <Typography variant="h6">6. Termination</Typography>
        <p>
            We may terminate accounts that violate terms.
        </p>

        <Typography variant="h6">7. Liability</Typography>
        <p>
            We are not responsible for outcomes related to job applications.
        </p>

        <Typography variant="h6">8. Changes</Typography>
        <p>
            Terms may be updated at any time.
        </p>

        <Typography variant="h6">9. Contact</Typography>
        <p>Email: evolvedevlabs@gmail.com</p>
    </LegalPage>
);

export default Terms;
